module.exports = __webpack_public_path__ + "img/weight.79fdb7ea.svg";